<div class="info" *ngIf="selectedPOS && !connected">
    <div>
        <div class="POS-logo"
             [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/xero-connected-app.png)'}"></div>
        <!-- <div class="pos-title">Xero</div> -->
        <div class="write-up">Xero is a cloud-based small business accounting software with tools for managing
            invoicing,
            bank reconciliation, inventory, purchasing, expenses, bookkeeping and more.
        </div>
    </div>
</div>

<button type="button" (click)="connectXero()" class="btn btn-primary" *ngIf="!busy && !connected">Connect to Xero
</button>
<div *ngIf="busy" style="display: block; margin-left: auto;text-align: right;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                       animationDuration=".5s">
    </p-progressSpinner>
</div>
<div class="wizard-message box center margin-top-0" *ngIf="connected && message">
    <div [innerHTML]="message"></div>
</div>
<div class="wizard-message fail center margin-top-16" *ngIf="message && !connected">
    <div [innerHTML]="message"></div>
</div>

<div *ngIf="connected"
     style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>

<div *ngIf="partner.VerificationID" class="margin-top-32">
    <div class="row">
        <div class="col-md-6">
            <button pButton (click)="skipToHubtiger()" class="p-button alternate full-width"
                    label="{{ 'onboarding.button.skip_to_hubtiger' | translate}}" *ngIf="!connected"></button>
        </div>
        <div class="col-md-6">
            <button pButton type="button" (click)="done()" class="p-button primary full-width" disabled="!connected"
                    label="{{ 'onboarding.button.done' | translate}}"></button>
        </div>
    </div>
</div>
